const ES = {
    sunday: 'D',
    monday: 'L',
    tuesday: 'M',
    wednesday: 'M',
    thursday: 'J',
    friday: 'V',
    saturday: 'S',
    ok: 'Aceptar',
    yesterday: 'Ayer',
    today: 'Hoy',
    last7Days: 'Últimos 7 días',
    thisMonth: 'Este mes',
};

export default ES;
